const Utils = {
    capitalize: text => {
        return text ? `${text.charAt(0).toUpperCase()}${text.substring(1)}` : '';
    },
    isMobile: () => {
        return document.documentElement.clientWidth <= 768;
    },
    isTablet: () => {
        return document.documentElement.clientWidth > 768 && document.documentElement.clientWidth <= 1024;
    },
    formatCurrency: (value) => {
        let num = parseFloat(value);
        if(isNaN(num)) {
            return '$0.00';
        }
        return `$${num.toFixed(2)}`;
    },
    hexToRGBA: (hex, alpha) => {
        if(!hex) {
            return 'rgba(0,0,0,0)';
        }
        let r = parseInt(hex.slice(1, 3), 16);
        let g = parseInt(hex.slice(3, 5), 16);
        let b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r},${g},${b},${alpha || 1})`;
    },
    adjustColor: (color, percent) => {
        var R = parseInt(color.substring(1,3), 16);
        var G = parseInt(color.substring(3,5), 16);
        var B = parseInt(color.substring(5,7), 16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        var RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

        return '#' + RR + GG + BB;
    },
    scrollToElement: (id) => {
        let element = document.getElementById(id);
        if(element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    },
    // First sentence of a description, for short intros that don't end mid-word.
    // Falls back to a character trim when there's no sentence break.
    firstSentence: (text, maxLength = 160) => {
        if(!text) {
            return '';
        }
        const match = text.match(/^.+?[.!?](?=\s|$)/);
        return match && match[0].length <= maxLength ? match[0] : Utils.truncateText(text, maxLength);
    },
    truncateText: (text, maxLength) => {
        if(!text || text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    },
    validateEmail: (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    },
    debounce: (func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(null, args), wait);
        };
    },
    getWindowSize: () => {
        return {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        };
    }
};

export default Utils;
